import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';

// 该组件除字体以外，其他样式与鲸海蓝一致
var getCollapseStyle = function getCollapseStyle(props) {
  var _getThemeData = getThemeData(props, 'collapse'),
    headerFontSize = _getThemeData.headerFontSize,
    contentFontSize = _getThemeData.contentFontSize;
  return css([".c7n-collapse{.c7n-collapse-header{font-size:", "px;}.c7n-collapse-content-box{font-size:", "px;}}"], headerFontSize, contentFontSize);
};
var collapseData = {
  name: 'collapse',
  data: [{
    headerFontSize: 14,
    contentFontSize: 12
  }],
  onlyTemplate: {
    base: getCollapseStyle
  }
};
export default collapseData;